import { useState } from "react";
import { DemandeAvoirDetail, gestesSur } from "@/composants/demandes-avoir";
import { Carte } from "@/composants/ui/carte";
import { Chargement, Erreur, Vide } from "@/composants/ui/etats";
import { messageDe, useChargement } from "@/lib/chargement";
import { api } from "@/lib/api";

/**
 * « Avoirs en cours » (LOT 2, tickets #44 et #47) : les demandes d'avoir
 * fournisseur en négociation et attendues, sur les commandes client que
 * l'appelant voit — le serveur applique le périmètre. Le montant ne s'affiche
 * qu'avec la permission de voir les montants ; les gestes, à qui agit sur la
 * commande client.
 */
export function PageAvoirsEnCours() {
  const { donnees, erreur, enCours, recharger } = useChargement(
    (signal) => api.avoirsEnCours(signal),
    [],
  );
  const [refus, setRefus] = useState<string | null>(null);

  if (erreur) return <Erreur message={erreur} onReessayer={recharger} />;
  if (!donnees || enCours) return <Chargement message="Chargement des avoirs en cours…" />;

  // Un geste répond la fiche de la commande ; ici, on relit la liste.
  const agir = async (geste: () => Promise<unknown>) => {
    setRefus(null);
    try {
      await geste();
      recharger();
      return true;
    } catch (cause) {
      setRefus(messageDe(cause));
      return false;
    }
  };

  return (
    <div className="flex flex-col gap-5">
      <div>
        <h1 className="text-xl font-semibold text-encre">Avoirs en cours</h1>
        <p className="mt-1 text-sm text-encre-douce">
          Ce que les fournisseurs doivent, ou devront s'ils l'acceptent : remises négociées,
          surplus gardés, gestes commerciaux. LABGEST suit ces demandes ; il ne les envoie pas au
          fournisseur.
        </p>
      </div>
      {refus ? (
        <p role="alert" className="text-sm text-alerte">
          {refus}
        </p>
      ) : null}
      {donnees.length === 0 ? (
        <Vide
          titre="Aucun avoir en cours"
          detail="Aucune demande d'avoir n'est en négociation ni n'attend son avoir."
        />
      ) : (
        <Carte>
          <ul className="divide-y divide-filet">
            {donnees.map((demande) => (
              <li key={demande.id} className="px-4 py-3">
                <DemandeAvoirDetail
                  demande={demande}
                  avecCommande
                  gestes={gestesSur(demande.commande_fournisseur_id, demande.id, agir)}
                />
              </li>
            ))}
          </ul>
        </Carte>
      )}
    </div>
  );
}
